module.exports = __webpack_public_path__ + "img/fwzt04_1.bf70dfb.png";